import { render, staticRenderFns } from "./SoilHistory.vue?vue&type=template&id=38914d86&scoped=true"
import script from "./SoilHistory.vue?vue&type=script&lang=js"
export * from "./SoilHistory.vue?vue&type=script&lang=js"
import style0 from "./SoilHistory.vue?vue&type=style&index=0&id=38914d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38914d86",
  null
  
)

export default component.exports